document.addEventListener("DOMContentLoaded", function () {

    // ==========================================
    // 1. MEASUREMENT FORM LOGIC
    // ==========================================
    const prevButton = document.getElementById("customize-action-previous");
    const nextButton = document.getElementById("customize-action-next");
    const reviewButton = document.getElementById("customize-action-review");
    const submitButton = document.getElementById("customize-action-submit");
    const measurementItems = document.querySelectorAll(".item.vmeasurement-owl-item");
    const inputs = document.querySelectorAll('.measurment_value');
    const progressBar = document.getElementById('v_progress_bar');

    let currentIndex = 0;
    const totalInputs = inputs ? inputs.length : 0;
    let filledInputs = 0;                                                                                                                                                                                               

    function updateProgress() {
        if (!progressBar || !inputs || totalInputs === 0) return;
        
        filledInputs = 0;
        inputs.forEach(input => {
            if (input.value.trim() !== '') {
                filledInputs++;
            }       
        });
        
        // Progress bar ki width update karna
        const progressPercentage = (filledInputs / totalInputs) * 100;
        progressBar.style.width = progressPercentage + "%";
    }

    // Har input change par progress bar update karna
    if(inputs) {
        inputs.forEach(input => {
            input.addEventListener('input', updateProgress);
        });
    }

    // ==========================================
    // 2. SWIPER INITIALIZATIONS
    // ==========================================

    // Customer Review Slider (HTML mein tha par JS mein missing tha)
    if(document.querySelector('.customer-review-slider .swiper')) {
        new Swiper('.customer-review-slider .swiper', {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
                nextEl: '.review-swiper-button-next',
                prevEl: '.review-swiper-button-prev',
            },
            breakpoints: {
                320: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 4 }
            }
        });
    }

    // Journey Slider (Syntax error fixed)
    if(document.querySelector('.journey')) {
        new Swiper('.journey', {
            loop: true,
            centeredSlides: true,
            slidesPerView: 4,
            spaceBetween: 30, 
            navigation: {
                nextEl: '.journey .swiper-button-next',
                prevEl: '.journey .swiper-button-prev',
            },  
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 20 },
                580: { slidesPerView: 3, spaceBetween: 20 },
                768: { slidesPerView: 2, spaceBetween: 30 },
                992: { slidesPerView: 4, spaceBetween: 20 }
            }
        });
    }

    // One Time Slider
    if(document.querySelector('.one-time')) {
        new Swiper('.one-time', {
            loop: true,
            slidesPerView: 1,
            speed: 300,
            autoHeight: true,
            navigation: {
                nextEl: '.one-time .swiper-button-next',
                prevEl: '.one-time .swiper-button-prev',
            }
        });
    }

    // Certificate Slider
    if(document.querySelector('.certificate')) {
        new Swiper('.certificate', {
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 9000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.certificate .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.certificate .swiper-button-next',
                prevEl: '.certificate .swiper-button-prev',
            }
        });
    }
   
}); // END DOMContentLoaded


// ==========================================
// 4. GLOBAL FUNCTIONS & SCROLL EVENTS
// ==========================================

function googleTranslateElementInit() {
    new google.translate.TranslateElement({ pageLanguage: 'en', layout: google.translate.TranslateElement.FloatPosition.TOP_LEFT }, 'google_translate_element');
}

function reveal() {
    var reveals = document.querySelectorAll(".tablinks");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("in-view");
        } else {
            reveals[i].classList.remove("in-view");
        }
    }
}
window.addEventListener("scroll", reveal);

// Line drawing animation on scroll
window.addEventListener('scroll', function () {
    const drawLine = document.querySelector('.draw-line');
    if (drawLine) {
        if (window.scrollY > 200) {
            drawLine.style.transition = "height 0.5s ease";
            drawLine.style.height = "100%";
        } else {
            drawLine.style.height = "1%";
        }
    }
});

function validateForm() {
    var name = document.getElementById("name1") ? document.getElementById("name1").value : "";
    var email = document.getElementById("email1") ? document.getElementById("email1").value : "";

    if (name === "" || email === "") {
        alert("Please fill in all fields.");
        return false;
    }
    window.location.href = "https://yogamanlab.com/pages/thank-you";
    return false;
}

function calculator() {
    var element1 = document.getElementById("div1");
    if(element1) element1.classList.add("mystyle");
    
    var element2 = document.getElementById("div2");
    if(element2) element2.classList.add("mystyli");
}

// ==========================================
// 5. PRODUCT TABS LOGIC
// ==========================================
let currentProductIndex = 0;
const products = [
    {
        title: "Sativa Bud",
        desc: "Nisl vel pretium lectus quam id leo in vitae. Pellentesque adipiscing commodo elit.",
        type: "Sativa-Dominant",
        thc: "THC 120.0-180.0 mg/g",
        cbd: "CBD 0.4-0.9 mg/g",
        img: "https://cdn.shopify.com/s/files/1/0317/4770/2919/files/Diab-99.9-type-1-Set-1.png?v=1693205678"
    },
    {
        title: "Indica Bud",
        desc: "Indica vel pretium lectus quam id leo in vitae. Pellentesque adipiscing commodo elit.",
        type: "Indica-Dominant",
        thc: "THC 150.0-200.0 mg/g",
        cbd: "CBD 0.5-1.0 mg/g",
        img: "//rayoflightthemes.com/wordpress-themes/herbalist-wordpress-theme/wp-content/uploads/2022/08/hero-img3-231.png"
    },
    {
        title: "Hybrid Bud",
        desc: "Hybrid vel pretium lectus quam id leo in vitae. Pellentesque adipiscing commodo elit.",
        type: "Hybrid",
        thc: "THC 130.0-190.0 mg/g",
        cbd: "CBD 0.3-0.8 mg/g",
        img: "//rayoflightthemes.com/wordpress-themes/herbalist-wordpress-theme/wp-content/uploads/2022/08/cannabis-hero-1.png"
    }
];
                 
function showProduct(index) {
    const productContent = document.getElementById("productContent");
    const productImage = document.getElementById("productImage");
    const tooltip = document.getElementById("tooltip");

    if (!productContent || !productImage) return;

    productContent.classList.add("fade-out");
    productImage.classList.add("fade-out");

    setTimeout(() => {
        const titleEl = productContent.querySelector("#productTitle");
        if(titleEl) titleEl.innerText = products[index].title;
        
        const descEl = productContent.querySelector("#productDesc");
        if(descEl) descEl.innerText = products[index].desc;
        
        const typeEl = productContent.querySelector("#productType");
        if(typeEl) typeEl.innerHTML = `<strong>${products[index].type}</strong>`;
        
        const thcEl = productContent.querySelector("#thcLevel");
        if(thcEl) thcEl.innerText = products[index].thc;
        
        const cbdEl = productContent.querySelector("#cbdLevel");
        if(cbdEl) cbdEl.innerText = products[index].cbd;

        productImage.src = products[index].img;

        if (tooltip) {
            tooltip.innerText = `THC: ${products[index].thc}\nCBD: ${products[index].cbd}`;
        }

        productContent.classList.remove("fade-out");
        productImage.classList.remove("fade-out");
    }, 300);
}
                              
// Ensure the product functions run after load
document.addEventListener("DOMContentLoaded", function () {
    const productContent = document.getElementById("productContent");
    if(productContent) {
        showProduct(currentProductIndex);
        
        const dots = document.querySelectorAll(".dot");
        dots.forEach((dot, index) => {
            dot.addEventListener("click", () => {
                currentProductIndex = index;
                showProduct(currentProductIndex);
                updateActiveDot();
            });
        });

        const prevBtn = document.getElementById("prevBtn");
        const nextBtn = document.getElementById("nextBtn");

        if (prevBtn) {
            prevBtn.addEventListener("click", () => {
                currentProductIndex = (currentProductIndex - 1 + products.length) % products.length;
                showProduct(currentProductIndex);
                updateActiveDot();
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener("click", () => {
                currentProductIndex = (currentProductIndex + 1) % products.length;
                showProduct(currentProductIndex);
                updateActiveDot();
            });
        }

        function updateActiveDot() {
            dots.forEach(d => d.classList.remove("active"));
            if(dots[currentProductIndex]) dots[currentProductIndex].classList.add("active");
        }
    }

    const tooltip = document.getElementById("tooltip");
    const imageContainer = document.querySelector('.image-container');
    if (imageContainer && tooltip) {
        imageContainer.addEventListener('mouseenter', () => { tooltip.style.display = 'block'; });
        imageContainer.addEventListener('mouseleave', () => { tooltip.style.display = 'none'; });
        tooltip.innerText = `THC: ${products[0].thc}\nCBD: ${products[0].cbd}`;
    }
});

       
